import React, { useCallback, useState } from 'react';
import { Check, Copy } from 'lucide-react';
import {
  isPortalDemoSupportEnabled,
  isValidFeedbackDiagCode,
  readPortalDemoSupportContext,
} from './portalCustomerFeedback';

interface FeedbackDiagCodeLineProps {
  diagCode: string | null | undefined;
  compact?: boolean;
}

/** Support-Code nur im bestehenden Labor-/Demo-Gate; die Textzeile bleibt manuell markierbar. */
export const FeedbackDiagCodeLine: React.FC<FeedbackDiagCodeLineProps> = ({
  diagCode,
  compact = false,
}) => {
  const [copied, setCopied] = useState(false);
  const visible = isPortalDemoSupportEnabled(readPortalDemoSupportContext());
  const code = String(diagCode ?? '').trim();
  const line = `Code für CODE CEO: ${code}`;

  const copy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(line);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1800);
    } catch {
      setCopied(false);
    }
  }, [line]);

  if (!visible || !isValidFeedbackDiagCode(code)) return null;

  return (
    <div
      className={`flex flex-wrap items-center justify-center gap-2 rounded-lg border border-cyan-400/20 bg-cyan-400/[0.06] ${
        compact ? 'px-2 py-1 text-[10px]' : 'px-3 py-2 text-xs'
      }`}
    >
      <code className="select-all break-all text-cyan-100">{line}</code>
      <button
        type="button"
        onClick={() => void copy()}
        className="inline-flex items-center gap-1 rounded border border-white/[0.1] px-1.5 py-0.5 text-cyan-200 transition-colors hover:bg-white/[0.06]"
        aria-label="Feedback-Code kopieren"
      >
        {copied ? <Check className="h-3 w-3" aria-hidden /> : <Copy className="h-3 w-3" aria-hidden />}
        {copied ? 'Kopiert' : 'Kopieren'}
      </button>
    </div>
  );
};
